export default "/8.png"